
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class OnboardService {

    getCachedOnboardData(userId: number): any {
      const cachedOnboardData = localStorage.getItem(`onboard_${userId}`);
      return cachedOnboardData ? JSON.parse(cachedOnboardData) : null;
    }
    
    cacheOnboardData(userId: number, data: any): void {
      const currentTime = new Date().getTime();
      const expiryTime = currentTime + (3 * 60 * 1000); // 3 minutes
      const dataToCache = { ...data, expiry: expiryTime };
      localStorage.setItem(`onboard_${userId}`, JSON.stringify(dataToCache));
    }
    
    isValidCachedData(data: any): boolean {
      const currentTime = new Date().getTime();
      console.log('Parsed expiry time:', new Date(data.expiry).toLocaleString());
      console.log('Current time:', new Date(currentTime).toLocaleString());
      // Log the evaluation of the expiry condition
      console.log('Is cached data valid:', data.expiry && currentTime < data.expiry);
      return data.expiry && currentTime < data.expiry;
    }
    
}
